export const getRatingOptions = () => {
  const ratingComponents = {
    styleOverrides: {
      root: {
        gap: '6px',
      },
      sizeSmall: {
        fontSize: '16px',
      },
      sizeMedium: {
        fontSize: '20px',
      },
      sizeLarge: {
        fontSize: '24px',
      },
    },
  };

  return { ratingComponents };
};
